<form [formGroup]="submissionDetailsForm" class="w-full overflow-x-hidden overflow-y-auto max-h-[calc(65vh-15px)]">

  <!-- General Details Section -->
  <div class="w-full flex flex-col items-start justify-start mt-5 mb-4 px-7">
    <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2">General Details</p>

    <div class="flex flex-row flex-wrap items-center gap-x-1 text-[13px] mb-4">
      <span class="font-bold text-[var(--base-text-alt-dark)]">Rep/Agent Name:</span>
      <span class="font-medium text-[var(--primary-dark)]" *ngIf="labSubmissionDetails?.creationUserId">{{ labSubmissionDetails?.creationUserName + ' ' + labSubmissionDetails?.creationUserSurname }}</span>
      <span class="mx-2.5 text-[var(--tertiary-text)]">|</span>
      <span class="font-bold text-[var(--base-text-alt-dark)]">Date Created:</span>
      <span class="font-medium text-[var(--primary-dark)] ml-1">{{creationDate | date: 'yyyy-MM-dd'}}</span>
      <span class="mx-2.5 text-[var(--tertiary-text)]">|</span>
      <span class="font-bold text-[var(--base-text-alt-dark)]">Lab Submission Type:</span>
      <span class="font-medium text-[var(--primary-dark)] ml-1">{{submissionTypes.length > 0 && labSubmissionDetails?.labManTypesId ? submissionTypes[labSubmissionDetails.labManTypesId - 1].description : '-'}}</span>
    </div>

    <section class="w-full flex flex-wrap items-start gap-x-4">
      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Agronomist</mat-label>
          <mat-select formControlName="agronomistUserId">
            <mat-option style="background-color: white!important; padding: 6px!important;">
              <div class="flex justify-center">
                <ngx-mat-select-search placeholderLabel="Search Agronomist" [formControl]="agronomistFilterCtrl">
                  <span ngxMatSelectNoEntriesFound>No entries found</span>
                </ngx-mat-select-search>
              </div>
            </mat-option>
            <mat-option *ngFor="let agronomist of filteredAgronomistList | orderBy: 'userIdName'" [value]="agronomist.userIdId">
              {{agronomist?.userIdName + ' ' + agronomist?.userIdSurname}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Lab</mat-label>
          <mat-select formControlName="labManLabId" [disabled]="hasOneAnalysis">
            <mat-option *ngFor="let lab of labList" [value]="lab.id">
              {{lab?.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Agent Lab Ref.Number</mat-label>
          <input matInput formControlName="agentLabRef" maxlength="25">
        </mat-form-field>
      </div>
    </section>
  </div>

  <div class="h-px bg-[var(--app-base)]"></div>

  <!-- Customer Details Section -->
  <div class="w-full flex flex-col items-start justify-start mt-5 mb-4 px-7">
    <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2">Customer Details</p>

    <section class="w-full flex flex-col items-start">
      <div class="w-full flex flex-row flex-wrap items-center">
        <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
          <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
            <mat-label appRemoveAriaOwns>Client</mat-label>
            <!-- selectionChange, not a (click) on the options. Choosing with the keyboard goes
                 through MatSelect's key manager, which calls _selectViaInteraction() and never
                 dispatches a DOM click, so searching and pressing Enter set the value but ran
                 none of the work that fills in the rest of the customer. -->
            <mat-select [disabled]="labSubmissionDetails?.labManStatusId === 1 || hasOneSample" matInput formControlName="otcCustomerDetailId" (selectionChange)="clientDetailChanged()">
              <mat-option style="background-color: white!important; padding: 6px!important;">
                <div class="flex justify-center">
                  <ngx-mat-select-search placeholderLabel="Search Client" [formControl]="clientFilterCtrl">
                    <span ngxMatSelectNoEntriesFound>No entries found</span>
                  </ngx-mat-select-search>
                </div>
              </mat-option>
              <mat-option *ngFor="let customer of filteredClientList | orderBy: 'name'" [value]="customer.id">
                {{customer?.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
          <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
            <mat-label appRemoveAriaOwns>Contact Person</mat-label>
            <input matInput formControlName="contactPerson" maxlength="30">
          </mat-form-field>
        </div>

        <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
          <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
            <mat-label appRemoveAriaOwns>Contact Number</mat-label>
            <input matInput formControlName="contactNumber" maxlength="13">
          </mat-form-field>
        </div>
      </div>

      <!--
        THE ADDRESS IS CHOSEN, NOT INFERRED. A submission links to a customer and a payer
        and never to an order, so nothing in it says which of a customer several
        addresses is the relevant one. It used to show whichever row the screen picked and
        the lab sheet picked a different one, which is what the client reported.

        Choosing is a form change like any other: nothing is written until Save.
      -->
      <div class="flex flex-col mt-2 mb-4 w-full max-w-[560px]">
        <!-- Off means the customer own address, which is what every submission made
             before this feature uses. Same shape as the alternative address box on an
             order in Order Manager. -->
        <mat-checkbox class="text-[13px] mb-1"
                      [checked]="useAltAddress"
                      [disabled]="!addressEditable"
                      (change)="onUseAltAddressChange($event.checked)">
          Use an alternative address
        </mat-checkbox>

        <!-- Disabled rather than hidden, so the control is visibly there and the reason is
             visibly next to it. Hiding it is what left somebody hunting for a button that
             had quietly gone. -->
        <p *ngIf="addressDisabledReason" class="text-[12px] text-[var(--tertiary-text)] m-0 mb-2">
          {{ addressDisabledReason }}
        </p>

        <!--
             gap-4 so the button is not crowded against the dropdown, and mb-3 for the
             space below the row.

             ALIGNMENT. An outline mat-form-field reserves space under itself for a hint
             or an error even when it has neither, so items-end used to align the button
             with the bottom of that empty space rather than with the field, and a hand
             tuned mb on the button only traded one misalignment for another.
             subscriptSizing="dynamic" collapses the reserved space, so the two line up
             by construction and there is no magic number to drift.
        -->
        <div class="flex items-end gap-4 flex-wrap mb-3" *ngIf="useAltAddress">
          <mat-form-field class="flex-1 min-w-[280px]" appearance="outline" subscriptSizing="dynamic">
            <mat-label appRemoveAriaOwns>Alternative Address</mat-label>
            <mat-select formControlName="otcTenantAddressId">
              <mat-option *ngFor="let address of altAddresses" [value]="address.id">
                {{ addressLabel(address) }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button type="button" (click)="openAddAddress()"
                  [disabled]="!addressEditable"
                  class="h-[42px] py-2 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-[12px] font-semibold bg-white text-[var(--primary-dark)] cursor-pointer hover:border-[var(--primary-dark)] transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap">
            + Add address
          </button>
        </div>

        <!-- Said plainly, because an empty dropdown with no explanation reads as a
             screen that has not finished loading. -->
        <p *ngIf="addressEditable && useAltAddress && !altAddresses.length && !loadingAddresses"
           class="text-[12px] text-[var(--tertiary-text)] m-0 mb-2">
          This customer has no alternative addresses. Add one to use a different address.
        </p>

        <!--
          The whole address, every field. The screen showed line 1, town and code, which
          is why the province never appeared. Somebody choosing between addresses has to
          be able to see what they differ by.
        -->
        <!--
          What will actually print: the chosen alternative, or the customer own address
          when the toggle is off. The province is deliberately not here; the lab sheet
          and the reports have no room for it either.

          NO MARGIN ON ANY LINE. Every line used to carry mb-1, so a three line address
          added spacing six times over and pushed everything under it down. Line height
          alone separates them now, and the block is only as tall as the lines in it.

          A ROW PER LABEL, not two independent columns. The labels and the values used to
          be separate stacks, so an address with a line 2 or a line 3 gave the value
          column more rows than the label column and Town and Code slid down out of line
          with their own headings. The address lines now sit inside the Address row, so
          however many of them there are, Town and Code stay beside their labels and
          nothing below moves.
        -->
        <div class="flex flex-col" *ngIf="selectedAddress">
          <div class="flex flex-row items-start">
            <p class="text-[13px] font-bold m-0 w-[120px] shrink-0">Address:</p>
            <div class="flex flex-col ml-2">
              <p class="text-[13px] m-0">{{ selectedAddress.addressLine1 ?? '-' }}</p>
              <p class="text-[13px] m-0" *ngIf="selectedAddress.addressLine2">{{ selectedAddress.addressLine2 }}</p>
              <p class="text-[13px] m-0" *ngIf="selectedAddress.addressLine3">{{ selectedAddress.addressLine3 }}</p>
            </div>
          </div>

          <div class="flex flex-row items-start">
            <p class="text-[13px] font-bold m-0 w-[120px] shrink-0">Town:</p>
            <p class="text-[13px] m-0 ml-2">{{ selectedAddress.town ?? '-' }}</p>
          </div>

          <div class="flex flex-row items-start">
            <p class="text-[13px] font-bold m-0 w-[120px] shrink-0">Code:</p>
            <p class="text-[13px] m-0 ml-2">{{ selectedAddress.postalCode ?? '-' }}</p>
          </div>
        </div>

        <p *ngIf="chosenCustomerId && !selectedAddress && !loadingAddresses"
           class="text-[12px] text-[var(--tertiary-text)] m-0">
          This customer has no address on record.
        </p>
      </div>
    </section>
  </div>

  <div class="h-px bg-[var(--app-base)]"></div>

  <!-- Order Details Section -->
  <div class="w-full flex flex-col items-start justify-start mt-5 mb-4 px-7">
    <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2">Order Details</p>

    <section class="w-full flex flex-wrap items-start gap-x-4">
      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Account (Payer)</mat-label>
          <mat-select formControlName="orderAccountId">
            <mat-option style="background-color: white!important; padding: 6px!important;">
              <div class="flex justify-center">
                <ngx-mat-select-search placeholderLabel="Search Payer" [formControl]="payerFilterCtrl">
                  <span ngxMatSelectNoEntriesFound>No entries found</span>
                </ngx-mat-select-search>
              </div>
            </mat-option>
            <mat-option (onSelectionChange)="checkCoOp(customer)" *ngFor="let customer of filteredPayerList | orderBy: 'name'" [value]="customer.id">
              {{customer?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="checkPayerType()" class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>CO-OP Order Number</mat-label>
          <input matInput formControlName="coopNo" maxlength="25">
        </mat-form-field>
      </div>

      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Order Date</mat-label>
          <input matInput [max]="currentDate" [matDatepicker]="picker1" formControlName="orderDate">
          <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Courier</mat-label>
          <input matInput formControlName="courier" maxlength="25">
        </mat-form-field>
      </div>

      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Waybill No.</mat-label>
          <input matInput formControlName="waybillNumber" maxlength="25">
        </mat-form-field>
      </div>
    </section>

    <div class="w-full max-w-[36%] min-w-[300px] mb-6">
      <p class="text-[13px] font-semibold text-[var(--base-text-alt-dark)] mb-1">Notes/Comments</p>
      <textarea formControlName="note"
        class="border border-[var(--app-border)] bg-transparent w-full min-w-[220px] h-[140px] p-2 text-[12px] font-semibold text-[var(--base-text-alt-dark)] resize-none rounded"></textarea>
    </div>
  </div>

  <div class="h-px bg-[var(--app-base)]"></div>

</form>
